import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useState } from 'react';

const lifecycleOptions = [
  {
    value: 'RETR',
    label: 'Medicaid Invoice Retrieval Lifecycle',
    pluginCode: 'MCD_INV_RETR_LIFECYCLE_ACTION_PLUGIN',
  },
  {
    value: 'PROC',
    label: 'Medicaid Invoice Processing Lifecycle',
    pluginCode: 'MCD_INV_PROC_LIFECYCLE_ACTION_PLUGIN',
  },
  // {
  //   value: 'LOAD',
  //   label: 'Medicaid Invoice Load',
  //   pluginCode: 'MCD_INV_LOAD_ACTION_PLUGIN',
  // },
];

export const McdInvLifecycleDialog = ({ data, closeDialog }) => {
  const rsrc = useRsrc();
  const module = useModuleFromRoute();

  const [lifecycleOption, setLifecycleOption] = useState(lifecycleOptions[0].value);

  const submit = () => {
    const selected = lifecycleOptions.find((opt) => opt.value === lifecycleOption);
    const ids = data.selectedEntityIds;

    const job = {
      code: selected.pluginCode.replace('_ACTION_PLUGIN', ''),
      name: selected.label,
      module,
      entity: 'MCD_INV',
      entityId: ids.length === 1 ? ids[0] : undefined,
      rsrcCode: selected.pluginCode,
      reqParamJson: JSON.stringify({ ids }),
      cat: 'ACTION',
      queueExempt: selected.pluginCode === 'MCD_INV_RETR_LIFECYCLE_ACTION_PLUGIN',
    };

    rsrc.save('skdr', 'JOB', job).then((job) => {
      rsrc.start(job.id);
      closeDialog();
    });
  };

  return (
    <Dialog onClose={() => closeDialog()} open fullWidth data-test-id="mcd-inv-lifecycle-dialog">
      <DialogTitle>Run Lifecycle</DialogTitle>
      <DialogContent>
        <FormControl fullWidth sx={{ marginTop: '0.5rem' }}>
          <InputLabel>Lifecycle</InputLabel>
          <Select
            value={lifecycleOption}
            onChange={(e) => setLifecycleOption(e.target.value)}
            data-test-id="lifecycle-option-selector"
          >
            {lifecycleOptions.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} data-test-id="cancel-button">
          Cancel
        </Button>
        <Button onClick={submit} data-test-id="submit-button">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
